const GlobalSearchWorker = () => {
  onmessage = function (e) {
    const { value, searchTable } = e.data;
    const presentColumns = [];
    if (value === "") {
      postMessage(JSON.stringify({ presentColumns: [] }));
      return;
    }
    for (let i in searchTable) {
      const contentElement = searchTable[i];
      if (contentElement.match(value.toLowerCase())) {
        presentColumns.push(i);
        console.log(searchTable[i], i, contentElement, value, "searching", i++);
      }
    }
    postMessage(JSON.stringify({ presentColumns: presentColumns }));
  };
};

let code = GlobalSearchWorker.toString();
code = code.substring(code.indexOf("{") + 1, code.lastIndexOf("}"));

const blob = new Blob([code], { type: "application/javascript" });
const worker_script = URL.createObjectURL(blob);

export default worker_script;
